import { safeFetch } from "../utils/safeFetch";
import { buildApiError } from "../utils/apiErrors";

export const requestPasswordReset = async (email) => {
  const response = await safeFetch('/api/auth/forgot-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  }, 'requestPasswordReset');

  if (!response.ok) throw await buildApiError(response, 'Errore richiesta reset password');
  return await response.json();
};

export const resetPasswordWithToken = async ({ token, newPassword }) => {
  const response = await safeFetch('/api/auth/reset-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword }),
  }, 'resetPasswordWithToken');

  if (!response.ok) throw await buildApiError(response, 'Errore reset password');
  return await response.json();
};
